import React from 'react';
import { translations } from '../Text/translations';

const StbMaxExpired = ({ currentLang }) => {
    return (
        <div className='message'>
            <h2>{translations[currentLang].stbMaxLinkExpired}</h2>
            <p>{translations[currentLang].stbMaxLinkExpiredMessage}</p>
        </div>
    );
};

export default StbMaxExpired;
